import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CompanyGroupsPage from "./companyGroups.page";
import adminsApi from "../../../../configs/apis/admins";
import CompanyGroupDialog from "../../components/dialog/companyGroupDialog";
import AccessRights from "../../../../configs/constants/accessRights";

function CompanyGroupsContainer() {
  const navigate = useNavigate();

  const [groups, setGroups] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemPerPage, setItemPerPage] = useState(25);
  const [actionOpen, setActionOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [isCreateDialogOpen, setCreateDialogOpen] = useState(false);

  const canView = useSelector((state) => state.session.accessRights.includes(AccessRights.ADMIN_COMPANY_GROUP_VIEW));
  const canEdit = useSelector((state) => state.session.accessRights.includes(AccessRights.ADMIN_COMPANY_GROUP_EDIT));

  useEffect(() => {
    if (!canView) {
      navigate("/admin");
    }
  }, [canView]);

  const handleActionOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setActionOpen(true);
  };

  const handleEdit = async () => {
    setEditDialogOpen(true);
  };

  const handleItemPerPageChange = (value) => {
    setItemPerPage(value);
  };

  const onPageClick = async (newPage) => {
    setCurrentPage(newPage);
  };

  const fetch = () => {
    setIsLoading(true);
    adminsApi
      .getCompanyGroups({ page: currentPage, length: itemPerPage })
      .then((response) => {
        const { data: payload } = response;
        console.log(payload);

        setGroups(payload.data);
        setTotalRows(payload.total);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetch();
  }, [currentPage, itemPerPage]);

  const onCreateClick = () => {
    setCreateDialogOpen(true);
  };

  const handleCreate = async (value) => {
    adminsApi
      .createCompanyGroup(value)
      .then((response) => {
        console.log(response);
      })
      .then(() => {
        fetch();
        setCreateDialogOpen(false);
      });
  };

  const handleEditSubmit = async (value) => {
    adminsApi
      .updateCompanyGroup({ uuid: selected.uuid, ...value })
      .then((response) => {
        console.log(response);
      })
      .then(() => {
        fetch();
        setEditDialogOpen(false);
      });
  };

  const handleClose = () => {
    setAnchorEl(null);
    setActionOpen(false);
  };

  return (
    <>
      <CompanyGroupsPage
        groups={groups}
        totalRows={totalRows}
        page={page}
        itemPerPage={itemPerPage}
        actionOpen={actionOpen}
        setActionOpen={setActionOpen}
        handleActionOpen={handleActionOpen}
        handleEdit={handleEdit}
        anchorEl={anchorEl}
        onPageClick={onPageClick}
        handleItemPerPageChange={handleItemPerPageChange}
        currentPage={currentPage}
        isLoading={isLoading}
        setSelected={setSelected}
        selected={selected}
        onCreateClick={onCreateClick}
        canEdit={canEdit}
        handleClose={handleClose}
      />
      <CompanyGroupDialog
        open={isCreateDialogOpen}
        handleClose={() => setCreateDialogOpen(false)}
        handleSubmit={handleCreate}
      />
      <CompanyGroupDialog
        open={isEditDialogOpen}
        handleClose={() => setEditDialogOpen(false)}
        handleSubmit={handleEditSubmit}
        selected={selected}
      />
    </>
  );
}

export default CompanyGroupsContainer;
